
/**
 * 수강신청 유형
 */
export type GetEnrollment200EnrollmentType = typeof GetEnrollment200EnrollmentType[keyof typeof GetEnrollment200EnrollmentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEnrollment200EnrollmentType = {
  REGULAR: 'REGULAR',
  AUDIT: 'AUDIT',
  PREMIUM: 'PREMIUM',
  TRIAL: 'TRIAL',
} as const;
